import { mockUsers } from './mockData';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

export const authService = {
  async login(email, password) {
    await delay(800);
    
    const user = mockUsers.find(u => u.email === email && u.password === password);
    
    if (!user) {
      throw new Error('Invalid email or password');
    }
    
    const { password: _, ...userWithoutPassword } = user;
    const token = 'mock-jwt-token-' + Date.now();
    
    localStorage.setItem('authToken', token);
    localStorage.setItem('currentUser', JSON.stringify(userWithoutPassword));
    
    return {
      success: true,
      user: userWithoutPassword,
      token
    };
  },

  async loginWithGoogle() {
    await delay(1000);
    
    const googleUser = mockUsers.find(u => u.loginType === 'Federated' || u.loginType === 'Both');
    
    if (!googleUser) {
      throw new Error('No Google account linked');
    }
    
    const { password: _, ...userWithoutPassword } = googleUser;
    const token = 'mock-jwt-token-google-' + Date.now();
    
    localStorage.setItem('authToken', token);
    localStorage.setItem('currentUser', JSON.stringify(userWithoutPassword));
    
    return {
      success: true,
      user: userWithoutPassword,
      token
    };
  },

  async loginWithMicrosoft() {
    await delay(1000);
    
    const msUser = mockUsers.find(u => u.loginType === 'Federated' || u.loginType === 'Both');
    
    if (!msUser) {
      throw new Error('No Microsoft account linked');
    }
    
    const { password: _, ...userWithoutPassword } = msUser;
    const token = 'mock-jwt-token-ms-' + Date.now();
    
    localStorage.setItem('authToken', token);
    localStorage.setItem('currentUser', JSON.stringify(userWithoutPassword));
    
    return {
      success: true,
      user: userWithoutPassword,
      token
    };
  },

  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('currentUser');
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('currentUser');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  },

  getToken() {
    return localStorage.getItem('authToken');
  }
};
